<template>
    <div class="transactions-history__grid" >
        <HistoryRow
            v-for="(history, index) in histories"
            :history="history"
            v-bind="history"
            :key="index"
            :currencyDisplay="currencyDisplay"
            @cancelWithdrawal="$listeners.cancelWithdrawal"
            @ticketIdClick="$listeners.ticketIdClick"
        />
    </div>
</template>

<script>
    import HistoryRow from './HistoryRow.vue';

    export default {
        name: 'HistoryGrid',
        props: {
            histories: {
                type: Array,
                required: true
            },
            currencyDisplay: {
                type: String,
                required: true,
            }
        },
        components: {
            HistoryRow,
        }
    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/app/modules/userProfile/history/components/HistoryGrid.vue